import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const timestamp = new Date().getTime();

i18n
  .use(Backend) // load translation using http from /public/locales
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${timestamp}`,
    },
    fallbackLng: 'hu',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
